var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"white"},[_c('v-card-title',{staticClass:"justify-center",staticStyle:{"height":"100%"}},[_c('img',{attrs:{"src":((this.customBasePath) + "/logo.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }